import * as SearchActions from '../../state/search/search.action';
import App from '../../app';

const EVENT_TRACKING_NAME = 'assetList';
const AMPLITUDE_EVENT_NAME = 'Pageview: Assets';
const EVENT_TRACKING_ACTIONS = {
  exportClicked: 'exportClicked',
  transferClicked: 'transferClicked',
  editClicked: 'editClicked',
};

export class EquipmentListController {
  constructor($state, $ngRedux, $rootScope) {
    'ngInject';

    this.$state = $state;
    this.store = $ngRedux;
    this.showFilters = false;
    this.flex = $rootScope.flexPage;
  }

  $onInit() {
    this.unsubscribe = this.store.connect(this.mapStateToThis, SearchActions)(this);
    App.amplitude.track(AMPLITUDE_EVENT_NAME);
  }

  mapStateToThis(state) {
    const { search, assets, transfer } = state;
    const { query, exportInProgress } = search;
    const { currentPage, totalPages, totalCount } = assets;
    const { transferkeys = [] } = transfer;
    let notice = false;

    return {
      searchString: query,
      loading: search.inProgress,
      assets: assets.list,
      notice: notice,
      currentPage: currentPage,
      totalPages: totalPages,
      totalCount: totalCount,
      exportInProgress,
      hasTransferKeys: transferkeys.length > 0,
      selected: (assets.list || []).filter((a) => a.selected),
    };
  }

  addToDataLayer(data) {
    window.dataLayer.push({
      event: EVENT_TRACKING_NAME,
      data: { ...data },
    });
  }

  navigateToAsset(asset) {
    this.$state.go('equipment.detail', {
      equipmentId: asset.id,
      title: asset.name,
    });
  }

  toggleFilters() {
    this.showFilters = !this.showFilters;
  }

  hasMoreResults() {
    return this.currentPage < this.totalPages;
  }

  export() {
    this.addToDataLayer({
      action: EVENT_TRACKING_ACTIONS.exportClicked,
    });
    this.searchExport();
  }
  transfer() {
    this.addToDataLayer({
      action: EVENT_TRACKING_ACTIONS.transferClicked,
    });
  }

  update() {
    this.addToDataLayer({
      action: EVENT_TRACKING_ACTIONS.editClicked,
    });
    this.$state.go('equipment.edit');
  }
}
